import EyebrowLabel from '@/components/SolutionsTemplate/EyebrowLabel';
import styles from "@/styles/solutionsTemplate/keyBenefits.module.scss";
import GradientTitle from '@/components/SolutionsTemplate/GradientTitle';

interface Props {
    type: string,
    jsonData: any,
  }

  interface StatItemProps {
    number: string;
    description: string;
    variant: 'light' | 'medium' | 'dark';
    featured?: boolean;
    type: string;
  }

  const StatItem = ({ number, description, variant, featured = false, type }: StatItemProps) => {
    const variantStyles = {
      light: {
        text: 'text-[hsl(var(--orange-light))]',
        glow: 'shadow-[var(--glow-light)]',
        bg: 'bg-gradient-to-br from-[hsl(var(--orange-light)/0.1)] to-[hsl(var(--orange-light)/0.05)]',
      },
      medium: {
        text: 'text-[hsl(var(--orange-medium))]',
        glow: 'shadow-[var(--glow-medium)]',
        bg: 'bg-gradient-to-br from-[hsl(var(--orange-medium)/0.15)] to-[hsl(var(--orange-medium)/0.08)]',
      },
      dark: {
        text: 'text-[hsl(var(--orange-dark))]',
        glow: 'shadow-[var(--glow-dark)]',
        bg: 'bg-gradient-to-br from-[hsl(var(--orange-dark)/0.1)] to-[hsl(var(--orange-dark)/0.05)]',
      },
    };
  
    const style = variantStyles[variant];
  
    return (
      <div
        className={`
          relative rounded-2xl backdrop-blur-sm
          ${style.bg} ${style.glow}
          ${featured ? 'p-12 scale-110' : 'p-8'}
        `}
        style = {{
            textAlign: "center",
        }}
      >
        <div className="relative z-10">
          <div
            className={`
              font-bold tracking-tight mb-4
              ${style.text}
              ${featured ? 'text-6xl md:text-7xl' : 'text-5xl md:text-6xl'}
              ${featured ? (type === "retail" ? styles.textGradientRetail : (type === "transportation" ? styles.textGradientTransportation : styles.textGradientIndustries)) : ""}
            `}
          >
            {number}
          </div>
          <p
            className={`
              text-muted-foreground leading-relaxed
              ${featured ? 'text-base md:text-lg' : 'text-sm md:text-base'}
            `}
          >
            {description}
          </p>
        </div>
        
        {/* Decorative blur effect */}
        <div
          className={`
            absolute inset-0 rounded-2xl blur-2xl opacity-20
            ${style.bg}
          `}
        />
      </div>
    );
  };
  
export default function KeyBenefits({
    type,
    jsonData,
  }: Props) {


    return (
        <section 
          className="px-4"
          style = {{
            paddingLeft: "20px",
            paddingRight: "20px",
          }}>
            
            <EyebrowLabel type = {type} text = {jsonData.eyebrowLabel}/>

            <div style = {{width: "fit-content", margin: "0 auto", marginTop: "20px"}}>
                <GradientTitle 
                  text = {jsonData.title}
                  centeredText = {true}/>
            </div>
            
            <div className="container mx-auto max-w-7xl" style = {{marginTop: "20px"}}>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 items-center">
                <StatItem
                    number={jsonData.stats[0].number}
                    description={jsonData.stats[0].description}
                    variant="light"
                    type={type}
                />
                <StatItem
                    number={jsonData.stats[1].number}
                    description={jsonData.stats[1].description}
                    variant="medium"
                    featured
                    type={type}
                />
                <StatItem
                    number={jsonData.stats[2].number}
                    description={jsonData.stats[2].description}
                    variant="dark"
                    type={type}
                />
                </div>
            </div>

            <div 
              className = {styles.supportingLineDiv}
              dangerouslySetInnerHTML = {{__html: jsonData.supportingLine}} />
        </section>
    );
}